module.exports = __webpack_public_path__ + "img/money-bill-simple-wave.b03f45ab.svg";